export default "__VITE_ASSET__CXhrSpYp__"